import { ModalControls } from '@cyberia-studio/react-modal';
import { ReactNode } from 'react';

export const setDialog = (modalControls: ModalControls, component: ReactNode) => () => modalControls.set(component);
